import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import SuccessCard from './components/SuccessCard';
import SecurityTips from './components/SecurityTips';

const PasswordResetSuccess = () => {
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    if (countdown <= 0) {
      navigate('/login');
      return;
    }
    const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  const resetTime = new Date()?.toLocaleString('en-KE', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-8">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center mx-auto mb-4">
            <Icon name="Scale" size={32} color="white" />
          </div>
          <h1 className="text-2xl font-heading font-bold text-text-primary mb-2">LawDesk KE</h1>
          <p className="text-text-secondary">Legal Practice Management System</p>
        </div>

        {/* Success Card */}
        <div className="bg-surface rounded-lg shadow-card border border-border p-8 mb-4">
          <SuccessCard countdown={countdown} resetTime={resetTime} />
        </div>

        {/* Security Tips */}
        <div className="bg-surface rounded-lg shadow-card border border-border p-6">
          <SecurityTips />
        </div>

        {/* Manual Login Link */}
        <div className="text-center mt-6">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-sm text-text-secondary hover:text-primary transition-smooth"
          >
            <Icon name="ArrowLeft" size={16} />
            Go to Sign In now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetSuccess;
